<div id="heading" class="standard-heading">
  <h1>Gurmat Research and Sikh Heritage Centre</h1>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" routerLink="/"><a href="#">Home</a></li>
      <li class="breadcrumb-item"><a href="#">About Us</a></li>
      <li class="breadcrumb-item active" aria-current="page">Gurmat Research and Sikh Heritage Centre</li>
    </ol>
  </nav>
</div>

<section id="research-centre" class="py-5">
  <div class="container">
    <div class="card shadow-lg content-main-card border-0">
      <div class="card-body p-4 p-md-5">
        <h2 class="card-title text-center text-uppercase mb-3">Gurmat Research and Sikh Heritage Centre</h2>
        <hr class="mx-auto mb-5 custom-hr">

        <div class="intro-section mb-5">
          <p class="lead text-justify">
            The Gurmat Research and Sikh Heritage Centre at Guru Nanak Khalsa College, Yamuna Nagar, envisions the
            creation of a pioneering institution of research, reflection, and cultural preservation dedicated to the
            timeless teachings of the Sikh Gurus. The Centre seeks to bridge the sacred wisdom of Gurmat with the
            intellectual and social needs of the contemporary world.
          </p>
          <p class="lead text-justify">
            The Centre will serve as a living institution that integrates research, documentation, education, and
            outreach. It will stand as a model of value-based education where knowledge, ethics, and service converge.
            In essence, this Centre seeks to awaken the light of the Guru within every heart, guiding humanity toward
            truth, harmony, and spiritual awakening.
          </p>
        </div>

        <div class="accordion-wrapper mt-4">
          <details class="accordion-item" name="research-accordion" open>
            <summary class="d-flex justify-content-between align-items-center">
              <span>Relevance and Rationale</span>
              <span class="icon-toggle"></span>
            </summary>
            <div class="accordion-content p-4">
              <p class="lead text-justify mb-0">
                The Centre will address an urgent cultural and spiritual needs. While Sikhism has a global presence,
                research, preservation, and dissemination remain fragmented. The Centre will offer systematic research,
                interdisciplinary inquiry, and rigorous documentation, interpreting Sikh teachings in ways that respond
                to contemporary ethical, social, and environmental challenges.
              </p>
            </div>
          </details>

          <details class="accordion-item mt-3" name="research-accordion">
            <summary class="d-flex justify-content-between align-items-center">
              <span>Philosophical Foundations</span>
              <span class="icon-toggle"></span>
            </summary>
            <div class="accordion-content p-4">
              <p class="lead text-justify mb-0">
                At the heart of the Centre is Gurmat, the living philosophy imparted by the Gurus. It integrates inward
                reflection with outward ethical action. The Centre will explore these ethical, aesthetic, and
                intellectual dimensions in scholarly depth, exploring the unity of existence and the defense of
                conscience and human dignity.
              </p>
            </div>
          </details>

          <details class="accordion-item mt-3" name="research-accordion">
            <summary class="d-flex justify-content-between align-items-center">
              <span>Cultural and Civilizational Significance</span>
              <span class="icon-toggle"></span>
            </summary>
            <div class="accordion-content p-4">
              <p class="lead text-justify mb-0">
                Sikh civilization combines spiritual vision with rich cultural expression. Sacred architecture,
                calligraphy, music, literature, and oral traditions reflect devotion, creativity, and discipline.
                The Centre will preserve and revitalize this heritage, creating a living repository of Sikh civilization
                accessible to scholars and the public alike.
              </p>
            </div>
          </details>

          <details class="accordion-item mt-3" name="research-accordion">
            <summary class="d-flex justify-content-between align-items-center">
              <span>Vision</span>
              <span class="icon-toggle"></span>
            </summary>
            <div class="accordion-content p-4">
              <p class="lead text-justify mb-0">
                The Centre envisions becoming a globally respected institution for Sikh philosophy, heritage, and
                culture. It will unite scholars, practitioners, artists, and seekers in a collaborative journey of
                reflection and dissemination, fostering an environment where spiritual wisdom informs scholarship and
                scholarly inquiry deepens spiritual understanding.
              </p>
            </div>
          </details>

          <details class="accordion-item mt-3" name="research-accordion">
            <summary class="d-flex justify-content-between align-items-center">
              <span>Mission</span>
              <span class="icon-toggle"></span>
            </summary>
            <div class="accordion-content p-4">
              <p class="lead text-justify mb-0">
                The Centre will advance understanding of Sikh philosophy and heritage through research, preservation,
                and dissemination. Interdisciplinary inquiry, dialogue across cultures, and creation of accessible
                resources will be prioritized. The mission is to preserve and reinterpret Sikh heritage while inspiring
                Seva, Simran, and Sangat in contemporary life. Activities will include publications, exhibitions,
                lectures, educational programs, and community engagement.
              </p>
            </div>
          </details>

          <details class="accordion-item mt-3" name="research-accordion">
            <summary class="d-flex justify-content-between align-items-center">
              <span>Core Objectives</span>
              <span class="icon-toggle"></span>
            </summary>
            <div class="accordion-content p-4">
              <ul class="lead text-justify mb-0" style="list-style-type: decimal; padding-left: 20px;">
                <li class="mb-2">Undertake systematic research on Sikh philosophy, theology, literature, ethics, and
                  social thought.</li>
                <li class="mb-2">Document and preserve manuscripts, sacred artefacts, music, oral histories, and
                  cultural expressions.</li>
                <li class="mb-2">Establish digital and physical archives accessible to scholars, educators, and the
                  public.</li>
                <li class="mb-2">Foster partnerships with universities, museums, and cultural organizations globally.
                </li>
                <li class="mb-2">Organize conferences, workshops, exhibitions, and heritage tours for knowledge
                  dissemination.</li>
                <li class="mb-2">Publish high-quality journals, monographs, and translations of rare Sikh texts.</li>
                <li class="mb-2">Develop training programs, fellowships, and educational modules for youth and
                  researchers.</li>
                <li class="mb-2">Apply Gurmat principles to contemporary ethical, social, ecological, and peacebuilding
                  challenges.</li>
                <li class="mb-2">Serve as a think tank for heritage preservation, value-based education, and policy
                  guidance.</li>
                <li class="mb-2">Inspire communities and individuals to integrate reflection, knowledge, and service in
                  daily life.</li>
              </ul>
            </div>
          </details>

          <details class="accordion-item mt-3" name="research-accordion">
            <summary class="d-flex justify-content-between align-items-center">
              <span>Strategic Pillars of Growth</span>
              <span class="icon-toggle"></span>
            </summary>
            <div class="accordion-content p-4">
              <ul class="lead text-justify mb-0" style="list-style-type: lower-alpha; padding-left: 20px;">
                <li class="mb-2"><strong>Research and Scholarship:</strong> Advanced interdisciplinary study of Sikh
                  thought, theology, and ethics.</li>
                <li class="mb-2"><strong>Heritage and Preservation:</strong> Conservation and digitization of
                  manuscripts, artefacts, and oral traditions.</li>
                <li class="mb-2"><strong>Education and Outreach:</strong> Engaging students, communities, and global
                  audiences through educational programs and public exhibitions.</li>
                <li class="mb-2"><strong>Innovation and Global Dialogue:</strong> Employing technology and partnerships
                  to project Sikh philosophy globally.</li>
              </ul>
            </div>
          </details>

          <details class="accordion-item mt-3" name="research-accordion">
            <summary class="d-flex justify-content-between align-items-center">
              <span>Community and Global Outreach</span>
              <span class="icon-toggle"></span>
            </summary>
            <div class="accordion-content p-4">
              <p class="lead text-justify mb-0">
                The Centre will engage communities globally through heritage walks, public lectures, digital
                storytelling, and youth fellowships. Programs in schools and colleges will integrate Sikh heritage and
                ethical principles into curricula. Social service initiatives including environmental conservation,
                peacebuilding, and ethical leadership will complement academic activities. Global partnerships will
                disseminate the values of Ik Onkar and universal brotherhood widely. The Centre will also encourage
                intercultural dialogue and shared learning among diverse faiths and traditions to promote mutual respect
                and harmony. Its outreach will inspire young minds to connect spiritual wisdom with contemporary global
                challenges. In doing so, the Centre will nurture a living movement of awareness, compassion, and service
                that transcends geographical and cultural boundaries.
              </p>
            </div>
          </details>

          <details class="accordion-item mt-3" name="research-accordion">
            <summary class="d-flex justify-content-between align-items-center">
              <span>Heritage Preservation and Innovation</span>
              <span class="icon-toggle"></span>
            </summary>
            <div class="accordion-content p-4">
              <p class="lead text-justify mb-3">
                Comprehensive documentation, restoration, and conservation of Sikh manuscripts, relics, and gurdwaras
                will be undertaken with utmost authenticity and scholarly precision. The Centre will work to preserve
                rare manuscripts, historical Hukamnamas, sacred artefacts, and architectural heritage associated with
                the Gurus, ensuring that the tangible and intangible legacy of Sikhism is safeguarded for future
                generations. Digital museums, virtual reality experiences, and online exhibitions will reimagine
                heritage for modern audiences, enabling people across the world to experience the sacred spaces and
                spiritual depth of Sikh history. High-resolution digitization and multimedia storytelling will make
                these
                treasures accessible to scholars, devotees, and learners alike.
              </p>
              <p class="lead text-justify mb-0">
                In parallel, specialized training programs in conservation science, digital archiving, and heritage
                management will be developed to build a new generation of professionals equipped to protect and
                interpret Sikh heritage with competence and devotion. Collaborative workshops with universities,
                museums, and cultural institutions will promote interdisciplinary research and innovation in
                preservation techniques. Through these efforts, the Centre will not only conserve the material symbols
                of the faith but also rekindle the timeless spirit of Gurmat that unites reverence, wisdom, and service.
              </p>
            </div>
          </details>

          <details class="accordion-item mt-3" name="research-accordion">
            <summary class="d-flex justify-content-between align-items-center">
              <span>Strategic Roadmap</span>
              <span class="icon-toggle"></span>
            </summary>
            <div class="accordion-content p-4">
              <div class="roadmap-item mb-3">
                <p class="lead text-justify"><strong>Phase I:</strong> Establish governance, infrastructure, and
                  baseline surveys.</p>
              </div>
              <div class="roadmap-item mb-3">
                <p class="lead text-justify"><strong>Phase II:</strong> Launch research projects, heritage
                  documentation, and initial publications.</p>
              </div>
              <div class="roadmap-item mb-3">
                <p class="lead text-justify"><strong>Phase III:</strong> Initiate educational programs, exhibitions,
                  outreach, and youth engagement.</p>
              </div>
              <div class="roadmap-item mb-0">
                <p class="lead text-justify"><strong>Phase IV:</strong> Build international collaborations, visiting
                  scholar programs, and sustainability measures including endowment funds.</p>
              </div>
            </div>
          </details>

          <details class="accordion-item mt-3" name="research-accordion">
            <summary class="d-flex justify-content-between align-items-center">
              <span>Collaborations and Sustainability Plan</span>
              <span class="icon-toggle"></span>
            </summary>
            <div class="accordion-content p-4">
              <p class="lead text-justify mb-4">
                The Centre will establish partnerships with national and international universities, research
                institutes, museums, and cultural organizations. Collaborative research projects, exchange programs, and
                joint conferences will enhance academic impact. Sustainability will be ensured through diversified
                funding including grants, endowments, sponsorships, and philanthropy. The Centre will also develop a
                robust alumni and community network to maintain long-term engagement and resource mobilization.
              </p>
              <div class="additional-links">
                <ul class="lead list-unstyled">
                  <li class="mb-3">
                    <div class="text-danger fw-bold mb-1" style="cursor: pointer;" routerLink="/about/seminar-conference">
                      <i class="bi bi-chevron-right small"></i> Seminars/Conferences
                    </div>
                  </li>
                  <li class="mb-3">
                    <div class="text-danger fw-bold mb-1" style="cursor: pointer;" routerLink="/about/research-project">
                      <i class="bi bi-chevron-right small"></i> Research Project
                    </div>

                  </li>
                  <li class="mb-2"><a href="#" class="text-decoration-none text-danger fw-bold"><i
                        class="bi bi-chevron-right small"></i> Book</a></li>
                  <li class="mb-2"><a href="#" class="text-decoration-none text-danger fw-bold"><i
                        class="bi bi-chevron-right small"></i> Archives</a></li>
                  <li class="mb-0"><a href="#" class="text-decoration-none text-danger fw-bold"><i
                        class="bi bi-chevron-right small"></i> MoUs/Collaborations</a></li>
                </ul>
              </div>
            </div>
          </details>
        </div>
      </div>
    </div>
  </div>
</section>